import React, { useState, useCallback, useEffect } from 'react'
import { useDebounce } from 'use-debounce'

import { Input, InputProps } from 'shadcdn/ui/input'

type Props = Omit<InputProps, 'onChange'> & {
  value?: string
  onChange: (value: string) => void
  debounceTime?: number
  placeholder?: string
  className?: string
}

export function DebouncedInput(props: Props) {
  const { value: externalValue, onChange, debounceTime = 300 } = props

  const [internalValue, setInternalValue] = useState<string>(externalValue || '')
  const [debouncedValue] = useDebounce(internalValue, debounceTime)

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setInternalValue(e.target.value)
  }, [])

  useEffect(() => {
    onChange(debouncedValue)
  }, [debouncedValue, onChange])

  useEffect(() => {
    if (externalValue !== undefined) {
      setInternalValue(externalValue)
    }
  }, [externalValue])

  const passedProps = {
    ...props,
    value: undefined,
    onChange: undefined,
    debounceTime: undefined,
  }
  delete passedProps['value']
  delete passedProps['onChange']
  delete passedProps['debounceTime']

  return <Input {...passedProps} value={internalValue} onChange={handleChange} />
}
